/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpgradeDeploymentStatusEnum } from './upgradeDeploymentStatusEnum';


export interface UpgradeInfo { 
    version: string;
    status: UpgradeDeploymentStatusEnum;
    irr_ami_id?: string;
    irr_ami_name: string;
    cdvx_ami_id?: string;
    cdvx_ami_name: string;
    lambda_zip_file_name: string;
    /**
     * Creation/Trigger date for the Deployment
     */
    deployed_date?: Date;
    /**
     * User who upgraded the deployment.
     */
    upgraded_by: string;
}
export namespace UpgradeInfo {
}


